import React from "react"
import {Modal,ModalBody,ModalHeader,ModalFooter} from "reactstrap"
export default (props)=>{
 
return (<Modal style={{zIndex:10000}}    isOpen={props.isOpen} >
    <ModalHeader>{props.title}</ModalHeader>
    <ModalBody style={{textAlign:"left"}}>{props.message}</ModalBody>
    <ModalFooter><button onClick={props.yes} className="btn btn-danger">OK</button>
    <button onClick={props.no} className="btn btn-info">Cancel</button>
    </ModalFooter>
</Modal> );

}